import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59db92c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = { class: "view-group-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-remake" }, "最多添加 10 个导航，拖动选中的导航可对其排序", -1))
const _hoisted_4 = { class: "image-group-list" }
const _hoisted_5 = { class: "image-right-box" }
const _hoisted_6 = { class: "image-item-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "标题", -1))
const _hoisted_8 = { class: "image-item-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "链接", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ui_upload_image_list = _resolveComponent("ui-upload-image-list")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_select_link = _resolveComponent("ui-select-link")!
  const _component_ui_close_btn = _resolveComponent("ui-close-btn")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ui_layout2, {
        title: "选择模板",
        class: "view-item-box"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.modelValue.orderMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.orderMode) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "oneline" }, {
                default: _withCtx(() => [
                  _createTextVNode("一行一个")
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "carousel" }, {
                default: _withCtx(() => [
                  _createTextVNode("轮播图")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_divider),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.modelValue.list,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.list) = $event)),
        filter: ".close-btn-box"
      }, {
        item: _withCtx(({ element, index }) => [
          (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "image-group-item-box"
          }, [
            _createVNode(_component_ui_upload_image_list, {
              modelValue: element.image,
              "onUpdate:modelValue": ($event: any) => ((element.image) = $event),
              showClose: false,
              tips: "更换图片"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(),
                _createVNode(_component_el_input, {
                  modelValue: element.title,
                  "onUpdate:modelValue": ($event: any) => ((element.title) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_ui_select_link, {
                  modelValue: element.link,
                  "onUpdate:modelValue": ($event: any) => ((element.link) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createVNode(_component_ui_close_btn, {
              onClick: _withModifiers(($event: any) => (_ctx.removeImage(index)), ["stop"])
            }, null, 8, ["onClick"])
          ]))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, { onClick: _ctx.addImage }, {
        default: _withCtx(() => [
          _createTextVNode("添加图片")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_divider),
    _createVNode(_component_ui_layout1, {
      title: "页面边距",
      class: "view-item-box"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_el_slider, {
          style: {"margin-left":"10px"},
          modelValue: _ctx.modelValue.pageGap,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.pageGap) = $event)),
          "show-input": "",
          class: "slider-style-box",
          max: 30,
          "show-input-controls": false
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.orderMode == 'oneline')
      ? (_openBlock(), _createBlock(_component_ui_layout1, {
          key: 0,
          title: "图片间距",
          class: "view-item-box"
        }, {
          content: _withCtx(() => [
            _createVNode(_component_el_slider, {
              style: {"margin-left":"10px"},
              modelValue: _ctx.modelValue.imageGap,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.imageGap) = $event)),
              "show-input": "",
              class: "slider-style-box",
              max: 30,
              "show-input-controls": false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ui_layout2, {
      title: "图片边角",
      class: "view-item-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.imageRadius,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.imageRadius) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "0" }, {
              default: _withCtx(() => [
                _createTextVNode("直角")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "8px" }, {
              default: _withCtx(() => [
                _createTextVNode("圆角")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}